import { render, staticRenderFns } from "./BoardClearedScreen.vue?vue&type=template&id=341e1d9f"
import script from "./BoardClearedScreen.vue?vue&type=script&lang=js"
export * from "./BoardClearedScreen.vue?vue&type=script&lang=js"
import style0 from "./BoardClearedScreen.vue?vue&type=style&index=0&id=341e1d9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports